/**
 * IntelliGems A/B Test: Facebook-style reviews (social proof)
 *
 * Control (A): data-fb-reviews-ab="false"
 * Variant (B): data-fb-reviews-ab="true"
 *
 * Desktop: 4 images visible, advance 1 item at a time
 * Mobile: 1 image per slide (arrows vertically centered)
 *
 * Dev preview: ?fb_reviews_test=b
 */
(function () {
  'use strict';

  if (window.__fbReviewsABTestInit) return;
  window.__fbReviewsABTestInit = true;

  var BODY_ATTR = 'data-fb-reviews-ab';
  var ACTIVE_CLASS = 'fb-reviews-ab--active';
  var MOBILE_MQ = '(max-width: 749px)';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;

  function isDevVariantB() {
    try {
      var v = new URLSearchParams(window.location.search).get('fb_reviews_test');
      return v === 'b' || v === 'true' || v === '1';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function initCarousels(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('[data-fb-reviews-carousel]');

    for (var i = 0; i < carousels.length; i++) {
      setupCarousel(carousels[i]);
    }
  }

  function setupCarousel(root) {
    if (!root) return;

    if (root.getAttribute('data-fb-reviews-ready') === 'true') {
      if (root._fbRevTeardown) root._fbRevTeardown();
    }

    var track = root.querySelector('[data-fb-reviews-track]');
    var viewport = root.querySelector('.fb-reviews-ab__viewport');
    var items = root.querySelectorAll('[data-fb-reviews-item]');
    var prevBtn = root.querySelector('[data-fb-reviews-prev]');
    var nextBtn = root.querySelector('[data-fb-reviews-next]');
    var dotsWrap = root.querySelector('[data-fb-reviews-dots]');

    if (!track || !viewport || items.length === 0) return;

    root.setAttribute('data-fb-reviews-ready', 'true');

    var desktopPerView = parseInt(root.getAttribute('data-desktop-per-view'), 10) || 4;
    var mobilePerView = parseInt(root.getAttribute('data-mobile-per-view'), 10) || 1;
    var autoplayDelay = parseInt(root.getAttribute('data-autoplay'), 10) || 4000;
    var index = 0;
    var totalPages = 1;
    var mq = window.matchMedia(MOBILE_MQ);
    var listeners = [];
    var autoplayTimer = null;

    function on(el, type, fn, opts) {
      if (!el) return;
      el.addEventListener(type, fn, opts);
      listeners.push({ el: el, type: type, fn: fn, opts: opts });
    }

    function getPerView() {
      return mq.matches ? mobilePerView : desktopPerView;
    }

    function getItemWidth() {
      var perView = getPerView();
      if (!viewport || !perView) return 0;
      return viewport.offsetWidth / perView;
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (totalPages <= 1) return;
      autoplayTimer = setInterval(function () {
        goTo(index + 1);
      }, autoplayDelay);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalPages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fb-reviews-ab__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('data-fb-reviews-dot', String(i));
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === index) btn.setAttribute('aria-current', 'true');
        dotsWrap.appendChild(btn);
      }
    }

    function updateChrome() {
      var hideNav = totalPages <= 1;
      if (prevBtn) prevBtn.hidden = hideNav;
      if (nextBtn) nextBtn.hidden = hideNav;
      if (dotsWrap) dotsWrap.hidden = hideNav;
    }

    function centerNav() {
      var stage = root.querySelector('.fb-reviews-ab__stage') || viewport.parentElement;
      var h = viewport ? viewport.offsetHeight : 0;
      if (!h && stage) h = stage.offsetHeight;
      if (!h) return;
      var topPx = Math.round(h / 2) + 'px';
      if (prevBtn) {
        prevBtn.style.top = topPx;
        prevBtn.style.transform = 'translateY(-50%)';
      }
      if (nextBtn) {
        nextBtn.style.top = topPx;
        nextBtn.style.transform = 'translateY(-50%)';
      }
    }

    function goTo(nextIndex) {
      if (totalPages <= 0) return;
      // Loop forever
      index = ((nextIndex % totalPages) + totalPages) % totalPages;
      var offset = Math.round(index * getItemWidth());
      track.style.transform = 'translateX(-' + offset + 'px)';

      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('[data-fb-reviews-dot]');
        for (var d = 0; d < dots.length; d++) {
          dots[d].classList.toggle('is-active', d === index);
          dots[d].setAttribute('aria-current', d === index ? 'true' : 'false');
        }
      }
      centerNav();
    }

    function recalc() {
      var perView = getPerView();
      totalPages = Math.max(1, items.length - perView + 1);
      if (index >= totalPages) index = totalPages - 1;
      buildDots();
      updateChrome();
      goTo(index);
      centerNav();
      restartAutoplay();
    }

    function onResize() {
      goTo(index);
      centerNav();
    }

    function onPrev() {
      goTo(index - 1);
      restartAutoplay();
    }

    function onNext() {
      goTo(index + 1);
      restartAutoplay();
    }

    function onDotsClick(event) {
      var target = event.target.closest('[data-fb-reviews-dot]');
      if (!target) return;
      var dotIndex = parseInt(target.getAttribute('data-fb-reviews-dot'), 10);
      if (!isNaN(dotIndex)) {
        goTo(dotIndex);
        restartAutoplay();
      }
    }

    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    function onTouchStart(event) {
      if (!event.touches || !event.touches.length) return;
      dragging = true;
      startX = event.touches[0].clientX;
      deltaX = 0;
      stopAutoplay();
    }

    function onTouchMove(event) {
      if (!dragging || !event.touches || !event.touches.length) return;
      deltaX = event.touches[0].clientX - startX;
    }

    function onTouchEnd() {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(deltaX) > 40) {
        goTo(deltaX > 0 ? index - 1 : index + 1);
      }
      deltaX = 0;
      restartAutoplay();
    }

    on(prevBtn, 'click', onPrev);
    on(nextBtn, 'click', onNext);
    on(dotsWrap, 'click', onDotsClick);
    on(track, 'touchstart', onTouchStart, { passive: true });
    on(track, 'touchmove', onTouchMove, { passive: true });
    on(track, 'touchend', onTouchEnd);
    on(window, 'resize', onResize);
    on(root, 'mouseenter', stopAutoplay);
    on(root, 'mouseleave', startAutoplay);

    var imgs = root.querySelectorAll('.fb-reviews-ab__img');
    for (var ii = 0; ii < imgs.length; ii++) {
      if (imgs[ii].complete) continue;
      on(imgs[ii], 'load', centerNav);
    }
    if (typeof ResizeObserver !== 'undefined' && viewport) {
      var ro = new ResizeObserver(function () {
        centerNav();
      });
      ro.observe(viewport);
      root._fbRevResizeObserver = ro;
    }

    function onMqChange() {
      recalc();
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
      listeners.push({ el: mq, type: 'change', fn: onMqChange, opts: undefined, isMq: true });
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onMqChange);
      listeners.push({ el: mq, type: 'change', fn: onMqChange, opts: undefined, isMq: true, legacy: true });
    }

    root._fbRevTeardown = function () {
      stopAutoplay();
      if (root._fbRevResizeObserver) {
        root._fbRevResizeObserver.disconnect();
        root._fbRevResizeObserver = null;
      }
      for (var i = 0; i < listeners.length; i++) {
        var L = listeners[i];
        if (L.isMq) {
          if (L.legacy && typeof L.el.removeListener === 'function') {
            L.el.removeListener(L.fn);
          } else if (typeof L.el.removeEventListener === 'function') {
            L.el.removeEventListener(L.type, L.fn);
          }
        } else {
          L.el.removeEventListener(L.type, L.fn, L.opts);
        }
      }
      listeners = [];
      root.removeAttribute('data-fb-reviews-ready');
      root._fbRevTeardown = null;
    };

    recalc();
    centerNav();
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      if (variantB === variantActive) {
        if (variantB) initCarousels();
        return;
      }

      variantActive = variantB;
      document.documentElement.classList.toggle(ACTIVE_CLASS, variantB);

      if (variantB) {
        initCarousels();
      }
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    initCarousels();
    applyVariant();

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (
          mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active'
        ) {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    document.addEventListener('gem:variant:changed', scheduleApply);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      if (event.target.querySelector && event.target.querySelector('[data-fb-reviews-carousel]')) {
        initCarousels(event.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
